// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

/* Hide default HTML checkbox */
.switch input {
  display: none;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #3fe85c;
}

input:checked + .slider:before {
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}`, "",{"version":3,"sources":["webpack://./src/components/VirtualPortal/css/buttonSlider.scss","webpack://./src/app/variables.scss"],"names":[],"mappings":"AACA,2CAAA;AACA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;AAAF;;AAGA,+BAAA;AACA;EAAe,aAAA;AACf;;AACA,eAAA;AACA;EACE,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;EAEA,gBAAA;AAEF;;AACA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,uBAAA;EAEA,gBAAA;AAEF;;AACA;EACE,yBCTc;ADWhB;;AACA;EAGE,2BAAA;AAEF;;AACA,oBAAA;AACA;EACE,mBAAA;AAEF;;AACA;EACE,kBAAA;AAEF","sourcesContent":["@import '../../../app/variables.scss';\n/* The switch - the box around the slider */\n.switch {\n  position: relative;\n  display: inline-block;\n  width: 60px;\n  height: 34px;\n}\n\n/* Hide default HTML checkbox */\n.switch input {display:none;}\n\n/* The slider */\n.slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  -webkit-transition: .4s;\n  transition: .4s;\n}\n\n.slider:before {\n  position: absolute;\n  content: \"\";\n  height: 26px;\n  width: 26px;\n  left: 4px;\n  bottom: 4px;\n  background-color: white;\n  -webkit-transition: .4s;\n  transition: .4s;\n}\n\ninput:checked + .slider {\n  background-color: $active-slider;\n}\n\ninput:checked + .slider:before {\n  -webkit-transform: translateX(26px);\n  -ms-transform: translateX(26px);\n  transform: translateX(26px);\n}\n\n/* Rounded sliders */\n.slider.round {\n  border-radius: 34px;\n}\n\n.slider.round:before {\n  border-radius: 50%;\n}\n","// Font colors\n$success-color: #38bb15;\n$warning-color: #feb52b;\n$error-color: #ff2e2e;\n$link-color: #428bca;\n\n$blue: #2d7cbf;\n$blue-light-gray: #d4e4e9;\n\n$lightest-gray: #f2f2f2;\n$light-gray: #eaeaea;\n$medium-lightest-gray: #dcdcdc;\n$medium-light-gray: #909092;\n$medium-gray: #c0c0c0;\n$medium-dark-gray: #606060;\n$dark-gray: #404040;\n\n$teal: #32c3b5;\n$gold: #f2b130;\n\n$light-base: #006AC7;\n$light-active: #264A82;\n$success-base: #00A76D;\n\n$eblack: #282829;\n$egrey: #dcddde;\n$evanta-blue: #4330ff;\n$evanta-blue-secondary: #5c4ee5;\n$gartner-blue: #002869;\n$active-slider: #3fe85c;\n$solar: #fa504b;\n$solar-secondary: #fb736f;\n$solar-tertiary: #DE0A01;\n\n\n// Font sizes\n$biggest-header: 36px;\n$big-header: 28px;\n$larger: 20px;\n$large: 16px;\n$medium: 14px;\n$small: 13px;\n$smaller: 12px;\n$tiny: 11px;\n\n// Homepage colors\n// $goldLight: #F9D889;\n// $goldPrimary: #F4B213;\n// $goldDark: #92451C;\n// $greenLight: #CDE3A5;\n// $greenPrimary: #9CC84B;\n// $greenDark: #416428;\n// $mintLight: #95E1DA;\n// $mintPrimary: #2BC4B6;\n// $mintDark: #00566B;\n// $purpleLight: #C6B1D4;\n// $purplePrimary: #8D64AA;\n// $purpleDark: #46295B;\n\n$goldLight: #F9D783;\n$goldPrimary: #92451C;\n$goldDark: #F5B51D;\n$greenLight: #C7E09A;\n$greenPrimary: #416428;\n$greenDark: #A0CA51;\n$mintLight: #8EDFD8;\n$mintPrimary: #02576C;\n$mintDark: #33C7B9;\n$purpleLight: #C3ADD2;\n$purplePrimary: #513465;\n$purpleDark: #9068AD;\n\n\n// virtual portal colors\n$vp-dark-gray: #6D6E71;\n$vp-black: #2C2C2C;\n$vp-bright-red: #FA504B;\n$vp-dark-gray-50op: rgba(109, 110, 113, 0.5)\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
